'use strict'

import http from './http-common'
import authHeader from './auth-header'
import useSWR from 'swr'

const getAll = (companyId) => {
  return http.axiosClient.get(`/healthcareFacilities?companyId=${companyId}`, {
    headers: authHeader()
  })
}

const revalidate = (companyId, mutate) => {
  mutate([`/healthcareFacilities?companyId=${companyId}`, { headers: authHeader() }])
}

const get = (id) => {
  return http.axiosClient.get(`/healthcareFacilities/${id}`, { headers: authHeader() })
}

const create = (data) => {
  return http.axiosClient.post('/healthcareFacilities', data, { headers: authHeader() })
}

const update = (id, data) => {
  return http.axiosClient.put(`/healthcareFacilities/${id}`, data, { headers: authHeader() })
}

const remove = (id) => {
  return http.axiosClient.delete(`/healthcareFacilities/${id}`, { headers: authHeader() })
}

export default {
  getAll,
  get,
  create,
  update,
  remove,
  revalidate
}
